
import React from "react";
import { RotateCcw } from "lucide-react";

interface ProfileGridProps {
  users: any[];
  isLoading: boolean;
  onRefresh: () => void;
  onProfileView: (userId: string, userProfile?: any) => void;
}

const ProfileGrid = ({ users, isLoading, onRefresh, onProfileView }: ProfileGridProps) => {
  const handleProfileClick = (user: any) => {
    onProfileView(user.user_id, user);
  };

  return (
    <div>
      <div className="grid grid-cols-3 grid-rows-2 w-full">
        {users.slice(0, 6).map((profile) => (
          <div
            key={profile.user_id}
            className="relative w-full aspect-square overflow-hidden cursor-pointer group bg-gray-900/50"
            onClick={() => handleProfileClick(profile)}
          >
            {profile.photo_urls?.[0] ? (
              <img 
                src={profile.photo_urls[0]} 
                alt={profile.display_name} 
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" 
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center">
                <div className="text-2xl font-bold text-gray-600">
                  {profile.display_name?.charAt(0) || '?'}
                </div>
              </div>
            )}
            
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
            
            {/* Online indicator */}
            {profile.isOnline && (
              <div className="absolute top-2 right-2 w-3 h-3 rounded-full bg-toxic-green shadow-lg border-2 border-white" />
            )}
            
            {/* Profile info overlay */}
            <div className="absolute bottom-0 left-0 right-0 p-2 text-white">
              <h3 className="font-semibold text-xs leading-tight mb-1">
                {profile.display_name || 'Unknown'}
              </h3>
              
              {profile.location && (
                <div className="flex items-center text-xs text-gray-300 mb-1">
                  <span className="truncate">{profile.location}</span>
                </div>
              )}
              
            </div>
          </div>
        ))}
      </div>
      
      {isLoading && (
        <div className="flex justify-center items-center py-6">
          <RotateCcw className="mr-2 h-4 w-4 animate-spin" />
          Loading profiles...
        </div>
      )}
      
      {!isLoading && users.length === 0 && (
        <div className="text-center py-6 text-ice-white/60">
          No profiles found. <button onClick={onRefresh} className="text-neon-red hover:underline">Refresh</button>
        </div>
      )}
    </div>
  );
};

export default ProfileGrid;
